import { useEffect } from "react";

export function useTableDynamicStyles(thColor, tbBorderColor, tdColor) {
  useEffect(() => {
    document.documentElement.style.setProperty("--thColor", thColor);
    document.documentElement.style.setProperty(
      "--tbBorderColor",
      tbBorderColor
    );
    document.documentElement.style.setProperty("--tdColor", tdColor);
  }, [thColor, tbBorderColor, tdColor]);
}
